import styled from 'styled-components';
import TickGreenSvg from '../../assets/hotels/tick-green.svg';

const TickGreenRound = styled(TickGreenSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '1.6rem'};
  height: ${props => props.height || '1.6rem'};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default TickGreenRound;
